import React from 'react'
import styled from 'styled-components'
import { AutoColumn } from '../../components/Column'
import { useAllTokenData } from '../../contexts/TokenData'
import TopTokenList from '../../components/@info/TokenList'
import { Search } from '../../components/@info/Search'
import { Updater as TokenDataContextUpdater } from '../../contexts/TokenData'
import { useTopTokens } from 'hooks/useTopTokens'


const PageWrapper = styled(AutoColumn)`
  max-width: 1230px;
  width: 100%;
`

const PageTitle = styled.h1`
  font-size: 25px;
  font-weight: 500;
  letter-spacing: 0.67px;
  margin-bottom: 16px;
  margin-top: 0;
`

export default function PageTokens() {
  // eslint-disable-next-line
  const allTokens = useAllTokenData()
  const topTokens = useTopTokens() // by IoSan

  // console.log('allTokens', allTokens)
  // console.log('topTokens', topTokens)

  return (
    <>
      <TokenDataContextUpdater />
      <PageWrapper>
        <PageTitle>Top Tokens</PageTitle>
        <Search />
        <div style={{ height: '17px' }} />
        <TopTokenList tokens={topTokens} itemMax={50} />
      </PageWrapper>
    </>
  )
}